const createRandomNum = () => {
  return Math.floor(Math.random() * 826) + 1;
};

export default createRandomNum;
